import { Text, View } from "@react-pdf/renderer";
import Column from "./column";

function VehicleSchedule({ vehiclesData }) {
  return (
    <View
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        marginTop: 30,
        width: "auto",
        marginLeft: 15,
        marginRight: 15,
      }}
    >
      <Text style={{ fontWeight: 600, fontSize: 30 }}>Vehicle Schedule</Text>
      {vehiclesData.vVinList.length !== 0 ? (
        <>
          <Text
            style={{
              fontWeight: 600,
              fontSize: 18,
              marginTop: 15,
              textAlign: "center",
            }}
          >
            It is hereby noted and agreed that only the vehicle(s) specified in
            the schedule are covered:
          </Text>
          <View
            style={{
              maxWidth: 700,
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "row",
              marginTop: 20,
            }}
          >
            <View
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
                border: "1.5px solid black",
                marginLeft: 10,
                marginRight: 10,
              }}
            >
              <Column columnName="VIN" items={vehiclesData.vVinList} />
              <Column columnName="Year" items={vehiclesData.vYearList} />
              <Column
                columnName="Make/Model"
                items={vehiclesData.vMakeModelList}
              />
              <Column columnName="Class" items={vehiclesData.vClassList} />
              <Column
                columnName="Body Type"
                items={vehiclesData.vBodyTypeList}
              />
              <Column
                columnName="Loss Payee"
                items={vehiclesData.vLossPayeeList}
              />
              <Column columnName="APD Limit" items={["$50,000"]} />
              <Column
                columnName="APD Deductible"
                items={vehiclesData.vDeductibleList}
              />
            </View>
          </View>
        </>
      ) : (
        <>
          <Text style={{ fontWeight: 600, fontSize: 18, marginTop: 15 }}>
            Vehicles are Excluded and{" "}
            <Text style={{ textDecoration: "underline" }}>not covered</Text>{" "}
            under this Policy
          </Text>
        </>
      )}
    </View>
  );
}
export default VehicleSchedule;
